import {DmsFlatRateUnit} from '../common/dms-flat-rate-unit';
import {DmsPart} from '../common/dms-part';
import {DmsSublet} from '../common/dms-sublet';
import {ServicePackage} from '../common/service-package';

export class GetPriceAndStockInformationRequestBody {
  brand: string;
  dmsCustomerId: string;
  dmsServiceOrderId: string;
  flatRateUnitList: DmsFlatRateUnit[];
  packageList: ServicePackage[];
  partList: DmsPart[];
  subletList: DmsSublet[];
  vin17: string;
  returnOnlyPrices: boolean;
}
